import { PageRoutes } from '../../app/pages/domain/constants/PageRoutes';
import { FlightListScope } from '../overview/domain/constants/FlightListScope';
import { AirportCodes } from '../../../types/airports';

export function getFlightsListUrl(
	airport: AirportCodes,
	scope?: FlightListScope,
	query?: string,
) {
	const searchParams = new URLSearchParams();
	if (scope) {
		searchParams.set('scope', scope);
	}

	if (query) {
		searchParams.set('query', query);
	}

	// TODO: change PageRoutes based on current airport selection
	const url = `/${airport}${PageRoutes.Flights}/?${searchParams.toString()}`;
	return url;
}
